// extracted by mini-css-extract-plugin
export default {"logoBarContainer":"LogoBar_logoBarContainer__alSRo","logoBarContainerImg":"LogoBar_logoBarContainerImg__+Dp3a"};